<template>
	<v-contextual-content :class="notificationsClass" class="notifications">
		<template v-slot:trigger="{ toggle }">
			<button
				title="Notifications" @click="toggle">Notifications
			</button>
		</template>
		<v-tabs
			ref="tabs" v-slot="{goToTab}" :tabless="true" :updateHash="false">
			<v-tab id="notifications" class="v-contextual__content__notifications" label="Notifications">
				<header class="flex gap-2 content-between items-center">
					<h1 class="beta heavy">Notifications</h1>
					<!--					<ul>-->
					<!--						<li>-->
					<!--							<button>Mark All As Read</button>-->
					<!--						</li>-->
					<!--						<li class="settings">-->
					<!--							<button-->
					<!--								class="" @click="goToTab('notification-settings')">Notification Settings-->
					<!--							</button>-->
					<!--						</li>-->
					<!--					</ul>-->
				</header>
				<div class="v-contextual__content__notifications__list">
					<div v-if="!Object.keys($authed().notifications).length" class="nothing-to-see-here">
						<p>You have not started a referral.</p>
					</div>
					<!--					<div-->
					<!--						v-if="!Object.keys($authed().notifications).length"-->
					<!--						class="v-contextual__content__notifications__list__empty center">-->
					<!--						<p>You don't have any notifications.</p>-->
					<!--					</div>-->
					<article
						v-for="(notification, notificationIndex) in $authed().notifications"
						v-else
						:key="notificationIndex"
						:class="notificationClass(notification)"
						class="v-contextual__content__notifications__list__notification">
						<header class="flex-apart">
							<div>
								<h2 class="delta heavy" v-html="notification.title"/>
								<dl class="notification__meta">
									<dt>Received</dt>
									<dd v-html="$present('dateTime', notification.createdAt)"/>
									<div class="notification__meta__read">
										<dt>Read</dt>
										<dd
											v-if="notification.readAt"
											v-html="$present('dateTime', notification.readAt)"/>
										<dd v-else>—</dd>
									</div>
								</dl>
							</div>
							<button @click="readNotification(notification)">View</button>
						</header>
					</article>
					<!--					<div>-->
					<!--						<div-->
					<!--							v-if="!Object.keys($authed().notifications).length"-->
					<!--							class="v-contextual__content__notifications__list__empty center">-->
					<!--							<p>You don't have any notifications.</p>-->
					<!--						</div>-->
					<!--						<article-->
					<!--							v-else-->
					<!--							v-for="(notification, notificationIndex) in $authed().notifications"-->
					<!--							class="v-contextual__content__notifications__list__notification"-->
					<!--							:class="notificationClass(notification)"-->
					<!--							:key="notificationIndex">-->
					<!--							<header class="flex-apart">-->
					<!--								<div>-->
					<!--									<h2 class="delta heavy" v-html="notification.title"/>-->
					<!--									<dl class="notification__meta">-->
					<!--										<dt>Received</dt>-->
					<!--										<dd v-html="$present('dateTime', notification.createdAt)"/>-->
					<!--										<div class="notification__meta__read">-->
					<!--											<dt>Read</dt>-->
					<!--											<dd-->
					<!--												v-if="notification.readAt"-->
					<!--												v-html="$present('dateTime', notification.readAt)"/>-->
					<!--											<dd v-else>—</dd>-->
					<!--										</div>-->
					<!--									</dl>-->
					<!--								</div>-->
					<!--								<button @click="readNotification(notification)">View</button>-->
					<!--							</header>-->
					<!--						</article>-->
					<!--					</div>-->
				</div>
			</v-tab>
			<v-tab id="notification" class="v-contextual__content__notification" label="Notification">
				<loader v-if="!activeNotification"/>
				<article
					v-else>
					<header>
						<h2 class="beta heavy" v-html="activeNotification.title"/>
						<dl class="notification__meta">
							<dt>Received</dt>
							<dd v-html="$present('dateTime', activeNotification.createdAt)"/>
						</dl>
						<button class="v-contextual__content__notification__back" @click="back()">Back</button>
					</header>
					<div class="notification__content">
						<div class="section--flat flex-even">
							<section class="metrics">
								<header>
									<h2 class="delta heavy center">Client Actions Required</h2>
								</header>
								<dl class="flex-apart">
									<div class="metrics__metric--number">
										<dt class="metrics__metric__stats__title">Registration</dt>
										<dd
											class="metrics__metric__stats__value --large"
											v-html="activeNotification.report.clients"/>
										<dd><router-link
											:to="parseQuery(activeNotification.report.clientsQuery)"
											class="metrics__metric--number__button button--text">View</router-link>
										</dd>
									</div>
									<div class="metrics__metric--number">
										<dt class="metrics__metric__stats__title">Payment</dt>
										<dd
											class="metrics__metric__stats__value --large"
											v-html="activeNotification.report.payments"/>
										<dd><router-link
											:to="parseQuery(activeNotification.report.paymentsQuery)"
											class="metrics__metric--number__button button--text">View</router-link>
										</dd>
									</div>
								</dl>
							</section>
						</div>
					</div>
				</article>
			</v-tab>
			<v-tab id="notification-settings" class="v-contextual__content__settings" label="Notification Settings">
				<header>
					<h1 class="beta heavy">Notification Settings</h1>
				</header>
				<form>
					<div>
						<section class="fieldset-section">
							<header>
								<h2>When a new notification arrives…</h2>
							</header>
							<label class="checkbox"><span>Open notification </span>
								<input type="checkbox">
							</label>
							<label class="checkbox"><span>Shake bell </span>
								<input type="checkbox">
							</label>
						</section>
					</div>
					<ul class="actions actions--right">
						<li>
							<button
								class="button button--primary" @click.prevent="goToTab('notifications')">Save
							</button>
						</li>
					</ul>
				</form>
			</v-tab>
		</v-tabs>
	</v-contextual-content>
</template>
<script>
export default {
	data() {
		return {
			loadingNotification: false,
			activeNotification: null,
		};
	},
	computed: {
		notificationsClass() {
			return {
				"nav--notifications--unread": Object.keys(this.$authed().notifications).length,
			};
		},
	},
	methods: {
		notificationClass(notification) {
			return {
				"v-contextual__content__notifications__list__notification--unread": !notification.readAt,
			};
		},
		readNotification(notification) {
			this.$refs.tabs.goToTab("notification");
			this.loadingNotification = true;
			http().get(this.route("notifications/:notification", notification)).then(response => {
				this.activeNotification = response.data.data;
				this.loadingNotification = false;
				this.$store.commit("authStore/UPDATE_NOTIFICATION", this.activeNotification);
			});
		},
		back() {
			this.$refs.tabs.goToTab("notifications");
			setTimeout(() => {
				this.activeNotification = null;
			}, 10);
		},
		parseQuery(query) {
			return {
				name: "clients.index",
				query: Qs.stringify(query),
			};
		},
	},
};
</script>
